import Vue from 'vue'
import { map, join } from 'lodash'

export default {
  fetch (queryParameters) {
    let queryParams = join(map(queryParameters, (value, key) => `${key}=${value}`), '&')
    
    return Vue.axios.get(`/api/v1/banner?${queryParams}`).then(response => response.data.data)
  },
}